import React, {useState} from 'react';
import {Box, Stack, Tab, Tabs, Typography} from '@mui/material';
import PageHeader from '../../global/components/PageHeader';
import TicketsAdminGrid from '../components/TicketsAdminGrid';
import {wrapperSx} from '@/global/helpers/globalstyles';
import {SchoolTicketsTable} from "@/modules/tickets/pages/schools/components/SchoolTicketsTable";
import {useSearchParams} from "react-router-dom";

const tabs = {
    user: {id: 0, label: `Пользователи`},
    school: {id: 1, label: `Школы`},
};

function TicketsAdminPage() {
    const [params, setParams] = useSearchParams();
    const tabParams = params.get('tab');
    const [tab, setTab] = useState(tabParams ? +(tabParams) : tabs.user.id);

    return (
        <Box
            className="App"
            sx={{height: '100%', display: 'flex', flexDirection: 'column'}}
        >
            <PageHeader/>
            <Box sx={wrapperSx}>

                <Stack
                    flexDirection={'row'}
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                >
                    <Typography
                        sx={{mt: 3}}
                        variant={'h5'}
                    >
                        <b>
                            Служба поддержки
                        </b>
                    </Typography>
                </Stack>

                <Tabs
                    value={tab}
                    onChange={(_e, newValue) => {
                        setTab(newValue);
                        setParams((prev) => {
                            prev.set('tab', newValue);
                            return prev;
                        });
                    }}
                    variant="scrollable"
                    scrollButtons={false}
                    sx={{mt: 2, ml: 2}}
                >
                    {Object.values(tabs).map(tab => (
                        <Tab
                            label={tab.label}
                            key={tab.id}
                            value={tab.id}
                        />
                    ))}
                </Tabs>

                {tab === tabs.user.id && <TicketsAdminGrid/>}

                {tab === tabs.school.id && <SchoolTicketsTable/>}
            </Box>
        </Box>
    );
}

export default TicketsAdminPage;